import React from 'react';

export default function InvoiceNumber(props) {
	return (
		<div className="InvoiceAddressSection md:mx-2 min-w-80 my-2 p-2">
			<h2 className="text-md">
				<strong>INVOICE NUMBER</strong>
			</h2>
			<span className="text-md">#00001RBO</span>
		</div>
	);
}
